import { render, staticRenderFns } from "./DynamicFieldModal.vue?vue&type=template&id=bd1b349c&scoped=true"
import script from "./DynamicFieldModal.vue?vue&type=script&lang=js"
export * from "./DynamicFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1b349c",
  null
  
)

export default component.exports